/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
    /**
     * See https://stripe.com/docs/api/payment_methods/customer_list
     * @type {Array<object>}
     * @memberof InlineResponse2009
     */
    paymentMethods: Array<object>;
}

export function InlineResponse2009FromJSON(json: any): InlineResponse2009 {
    return InlineResponse2009FromJSONTyped(json, false);
}

export function InlineResponse2009FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2009 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethods': json['paymentMethods'],
    };
}

export function InlineResponse2009ToJSON(value?: InlineResponse2009 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethods': value.paymentMethods,
    };
}


